import { render, staticRenderFns } from "./FaqWiki.vue?vue&type=template&id=47f1cec4&scoped=true"
import script from "./FaqWiki.vue?vue&type=script&lang=js"
export * from "./FaqWiki.vue?vue&type=script&lang=js"
import style0 from "./FaqWiki.vue?vue&type=style&index=0&id=47f1cec4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f1cec4",
  null
  
)

export default component.exports